class PatientImportValidationResult {
    public isValid: boolean;
    public validationMessageLabel: string;

    constructor(isValid: boolean, validationMessageLabel: string) {
        this.isValid = isValid;
        this.validationMessageLabel = validationMessageLabel;
    }
}

export { PatientImportValidationResult };
